import config from '~/config';
import http from './http';

export const getLoanTypes = async () => {
    try {
        const results = await http.get(`${config.urls.base}/loanType`);
        if (results.errored) {
            throw new Error(results.error);
        }

        return results;

    } catch (err) {
        console.error(err);
        return [];
    }
};

export default {
    getLoanTypes
};